import {AjaxPageTypes} from '../Settings';

/**
 * Utility class for ajax requests
 */
class AjaxUtility {

	/**
	 * Executes a ajax request to the server and returns a jqXHR Promise Object
	 * @param {string} type
	 * @param {object} data
	 * @param {string} url
	 * @returns {jqXHR|Promise}
	 */
	request(plugin, params = {}, url = window.location.origin) {
		let ajaxConfig = AjaxPageTypes[plugin];

		let data = {
			type: ajaxConfig.typeNum
		};

		data[ajaxConfig.pluginName] = params;

		return $.ajax({
			url: url,
			type: 'GET',
			data: data
		});
	}
}

export default (new AjaxUtility);
